<template>
  <div class="under-head-notification  container  _red">
    <div class="under-head-notification__content  container-inner">
      <div class="under-head-notification__text text">
        {{ $tGlobal('You have not completed filling out the questionnaire') }}
        <button @click.prevent="go"
                style="text-decoration: underline"
                class="inline-link  _white">
          <span>{{ $tGlobal('Go to questionnaire') }}</span>
          <BaseSvg name="ico-arrow-light"
                   width="0.5rem"
                   height="1rem"
                   style="margin-left: 0.4rem"
                   class="_arrow"/>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'YourResumeIsNotCompletedNotification',
    methods: {
      go() {
        this.$router.push({ name: 'response-additional-questions' }).catch(() => {});
      }
    }
  }
</script>

<style lang="less">

</style>
